
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pnwixjtohiegwfyswhgb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBud2l4anRvaGllZ3dmeXN3aGdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5NTc3MTUsImV4cCI6MjA2NTUzMzcxNX0.h6LDAI0XNNJMghwOkNPEhC5WwApHJPKTruuI4v6pZjQ";

// Headers de sécurité pour toutes les requêtes Supabase
const securityHeaders = {
  'X-Client-Info': 'nokodia-web-app',
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
  global: {
    headers: securityHeaders,
  },
});
